module.exports = __webpack_public_path__ + "img/icon-red-bin.14b3b9d4.svg";